import React from 'react';
import PropTypes from 'prop-types';
import VerticalDiagram from '../../Components/VerticalDiagram';
import Turnout from '../../Components/Turnout';
import { PeopleComponent as People } from '../../Components/People';
import { Title, Subtitle } from '../../Components/Header';
import { percentFormat } from '../../Utils/NumberFormatting'
import { Percent, Votes } from '../../Components/People/styles';
import labels from '../../Labels';
import { getHasElectionFinished, getHasElectionStarted, getSubtitleByStatus, getHasFirstRoundStarted } from '../../Utils/Getters';
import styled from 'react-emotion';

const RoundTitle = styled.span`
	font-size: 2.25rem;
	font-weight: 500;
`

const getNext = (districts, currentDistrict) => {
	return districts[(districts.indexOf(currentDistrict) + 1) % 27];
}

const getPrev = (districts, currentDistrict) => {
	return districts[(districts.indexOf(currentDistrict) + districts.length - 1) % 27];
}

export default function District(props) {
	const meta = props.meta[props.roundIndex];
	const electionHasStarted = getHasElectionStarted(meta)
	const electionHasFinished = getHasElectionFinished(meta)
	const hasFirstRoundStarted = getHasFirstRoundStarted(meta, props.roundIndex)
	const winAfterFirstRound = props.head2head.length === 1

	const diagramTitle = electionHasFinished || winAfterFirstRound ? labels.districtRouteTitle : labels.districtRouteTitleProvisional;

	return <>
		<Title.Input>Senátní volby {props.year} - {props.name}</Title.Input>
		<Subtitle.Input>
			<RoundTitle>{labels.round[props.roundIndex]}. kolo</RoundTitle>{getSubtitleByStatus(electionHasStarted, electionHasFinished)}
		</Subtitle.Input>
		{hasFirstRoundStarted && <VerticalDiagram
			title={diagramTitle[winAfterFirstRound ? 0 : props.roundIndex]}
			items={props.head2head}
			roundIndex={winAfterFirstRound ? 0 : props.roundIndex}
			prev={getPrev(props.districts, props.districtId)}
			next={getNext(props.districts, props.districtId)}
			faces={props.faces}
		/>}

		{electionHasStarted && <Turnout
			turnout={meta.turnout}
			count={meta.count}
		/>}

		{hasFirstRoundStarted ?
			<People
				title="Kolik získali kanditáti hlasů v 1. kole"
				items={props.candidates}
				show="percent"
				opened
				renderInfo={({ percent, votes } ) => (
					<>
						<Percent>{percentFormat(percent[0])}</Percent>
						<Votes>{votes[0]} hlasů</Votes>
					</>
				)}
			/> :
			<People
				title="Kandidáti do 1. kola"
				items={props.candidates}
				opened
				renderInfo={() => null}
			/>
		}
	</>;
}

District.propTypes = {
	candidates: PropTypes.arrayOf(PropTypes.object).isRequired,
	head2head: PropTypes.arrayOf(PropTypes.object).isRequired,
	meta: PropTypes.arrayOf(PropTypes.shape({
		turnout: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	})).isRequired,
	name: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	districtId: PropTypes.number.isRequired,
	roundIndex: PropTypes.oneOf([0, 1]).isRequired,
	faces: PropTypes.object.isRequired
}
